import { IcClose, IcHamburger } from "@/assets/menu";
import Logout from "@/components/Logout";
import { ROUTES } from "@/constants";
import { NavBarList } from "@/constants/NavMenu";
import { classNames } from "@/utils";
import { AuthContext } from "@services/AuthContext";
import { useContext, useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/penomo_logo.svg";
import "./NavBar.css";
import ExitConfirmationModal from "./Projects/GetFinancial/ExitConfirmationModal";

const NavBar = ({ handleLinkClick, setShowLogoutModal }: any) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line
  const { authToken } = useContext(AuthContext);
  const [showExitConfirmation, setShowExitConfirmation] = useState(false);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  const [isNavOpen, setIsNavOpen] = useState<boolean>(false);

  const isSetupProfilePage = pathname === ROUTES.PROFILE_SETUP;

  useEffect(() => {
    if (isNavOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isNavOpen]);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleExitConfirmation = () => {
    setShowExitConfirmation(false);
    navigate("/");
  };

  if (isSetupProfilePage) {
    return <></>;
  }

  return (
    <>
      <nav
        className={classNames(`lg:fixed lg:h-full w-full lg:w-[228px] bg-white`, {
          hidden: !authToken,
        })}
      >
        {isNavOpen && <div className="fixed inset-0 bg-white z-40 lg:hidden" />}

        <div
          className={`${
            windowHeight < 725 ? "lg:overflow-y-scroll" : "lg:overflow-y-none"
          } h-full flex flex-col justify-between px-4 lg:pl-8 lg:pr-0 lg:pb-5 py-5`}
        >
          <div className="w-full grow">
            <div className="w-full flex justify-between items-center relative z-50 lg:mb-16">
              <NavLink to={ROUTES.DASHBOARD} className="flex items-center pr-2">
                <img src={logo} className="h-7" alt="penomo" />
              </NavLink>
              <button
                data-collapse-toggle="navbar-default"
                type="button"
                className="inline-flex items-center justify-center text-sm text-monochrome-500 rounded-lg lg:hidden"
                aria-controls="navbar-default"
                aria-expanded={isNavOpen}
                onClick={() => setIsNavOpen(!isNavOpen)}
              >
                {isNavOpen ? <IcClose /> : <IcHamburger />}
              </button>
            </div>

            <div
              className={classNames("lg:block", isNavOpen ? "fixed inset-0 pt-[88px] bg-white z-40 overflow-y-auto" : "hidden", "lg:relative lg:pt-0")}
              id="navbar-default"
            >
              <ul className="pl-8 py-4 lg:pl-0 lg:py-0 bg-white font-medium w-full">
                {authToken && (
                  <>
                    <div className="flex flex-col gap-y-8 lg:justify-center">
                      {NavBarList.map((item, index) => (
                        <li key={"menu-" + (index + 8)}>
                          <NavLink
                            to={item.link}
                            className="flex justify-between"
                            onClick={(e) => {
                              handleLinkClick(e, item.link);
                            }}
                          >
                            {({ isActive }) => (
                              <>
                                <div className="flex justify-items-center">
                                  {isActive ? item.iconWhenSelected : item.icon}
                                  <span
                                    className={`pl-4 flex my-auto hover:text-primary-500 ${
                                      isActive ? "text-primary-500 text-xs font-bold" : "text-monochrome-50 text-xs font-normal"
                                    }`}
                                  >
                                    {item.title}
                                  </span>
                                </div>
                                {isActive ? <p className="w-[0.25rem] h-5 bg-primary-500" /> : null}
                              </>
                            )}
                          </NavLink>
                        </li>
                      ))}
                    </div>
                    <li className="lg:hidden mt-4">
                      <Logout />
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>

          <div className="hidden lg:block">
            <Logout />
          </div>
        </div>
      </nav>
      <ExitConfirmationModal show={showExitConfirmation} onClose={() => setShowExitConfirmation(false)} onConfirm={() => handleExitConfirmation(true)} />
    </>
  );
};

export default NavBar;
